import CurrentFundsBalanceError from './CurrentFundsBalanceError';
class CurrentBalancePropertyIsNotRegistered extends CurrentFundsBalanceError {
    propertyId;
    constructor(propertyId, options) {
        super('Property ID not registered for current balance', options);
        this.propertyId = propertyId;
    }
}
export default CurrentBalancePropertyIsNotRegistered;
